<div class="lg:px-6 px-1 py-5">
  <div class="surface-card p-4 shadow-2 border-round">
    <div class="flex flex-wrap gap-3">
      <button
        *ngIf="!hideContactDetails"
        type="button"
        pButton
        icon="pi pi-file-edit"
        label="Change Contact Details"
        class="w-full md:w-auto"
        (click)="showCustomerUpdateContactDetails(customer, $event)"
      ></button>
      <button
        *appHasPermission="'subscriptions.create'"
        type="button"
        pButton
        icon="pi pi-plus-circle"
        label="Add Subscription"
        class="w-full md:w-auto p-button-outlined"
        (click)="showAddSubscriptionDialog()"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-user-plus"
        label="Enable Customer"
        class="w-full md:w-auto p-button-success"
        [loading]="enablingCustomer"
        (click)="confirmEnableCustomer()"
      ></button>
      <button
        *ngIf="showHotspotLookup"
        type="button"
        pButton
        icon="pi pi-wifi"
        label="Hotspot Lookup"
        class="w-full md:w-auto p-button-outlined"
        (click)="hotspotLookupRequested.emit()"
      ></button>
    </div>
  </div>
</div>
